import { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import { addFavorite, getArticleById, getFeaturedImage, removeFavorite, updateArticle, uploadFeaturedImage } from "../../HTTP/articles";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { countries, languages } from "../../global/countriesAndSources";
import { getAllLanguagesFromCountry } from "../../HTTP/translation";
import DeleteIcon from '@mui/icons-material/Delete';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import constants from "../../HTTP/constants";
import { VISIBILITY_OPTIONS } from "../../Helper/visibilityOptions";

export default function MyArticlesEdit() {
    if (localStorage.getItem("subscriptions") === null) {
        window.location.href = '/'
    } else {
      if (JSON.parse(localStorage.getItem("subscriptions")).data === null) {
        window.location.href = '/'
      }
    }

    const user = JSON.parse(localStorage.getItem("user"))
    const { id } = useParams()
    const [formData, setFormData] = useState({
        id: id,
        user_id: user.id,
        title: '',
        description: '',
        language: '',
        image: null,
        imagePreview: '',
        currentImage: null,
        visible: 0,
        copyright: true, // Pour une image existante, on considère que les droits sont acquis
        rotation_featured_image: 0
    });
    const [languagesOfUser, setLanguagesOfUser] = useState([])
    const [favorites, setFavorites] = useState(JSON.parse(localStorage.getItem('favorites') || []));

    useEffect(() => {
        const funGetLanguages = async () => {
            const langFromUser = await getAllLanguagesFromCountry(user.country)
            setLanguagesOfUser(langFromUser)
        }
        funGetLanguages()
    }, [user.country])

    useEffect(() => {
        setFormData(prevData => ({
            ...prevData,
            language: languagesOfUser[0]
        }))
    }, [languagesOfUser])

    useEffect(() => {
        const fetchArticleData = async () => {
            try {
                const resArticle = await getArticleById(id);
                
                // Assurez-vous que rotation_featured_image est correctement récupérée
                // Si elle n'existe pas dans resArticle, utilisez 0 comme valeur par défaut
                const rotation = resArticle.rotation_featured_image !== undefined ? 
                    resArticle.rotation_featured_image : 0;
                
                if (resArticle.featured_image) {
                    const imageData = await getFeaturedImage(id);
                    setFormData(prevData => ({
                        ...prevData,
                        ...resArticle,
                        currentImage: imageData,
                        imagePreview: URL.createObjectURL(imageData),
                        copyright: true, // L'image existante est considérée comme ayant les droits
                        rotation_featured_image: rotation, // Assurez-vous d'initialiser la rotation ici
                        visible: Number(resArticle.visible || 0)
                    }));
                } else {
                    setFormData(prevData => ({
                        ...prevData,
                        ...resArticle,
                        rotation_featured_image: rotation, // Même ici, pour être cohérent
                        visible: Number(resArticle.visible || 0)
                    }));
                }
            } catch (error) {
                console.error("Erreur lors de la récupération des données:", error);
                alert("Erreur lors de la récupération des données de l'article");
            }
        };

        fetchArticleData();
    }, [id]);

    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;
        
        if (type === 'file') {
            const file = files[0];
            if (file) {
                if (!file.type.startsWith('image/')) {
                    alert('Veuillez sélectionner une image valide');
                    return;
                }
                
                if (file.size > 5 * 1024 * 1024) {
                    alert('L\'image ne doit pas dépasser 5MB');
                    return;
                }
                
                if (formData.imagePreview && formData.imagePreview !== formData.currentImage) {
                    URL.revokeObjectURL(formData.imagePreview);
                }
                
                setFormData(prevData => ({
                    ...prevData,
                    image: file,
                    imagePreview: URL.createObjectURL(file),
                    copyright: false, // Réinitialise le copyright pour la nouvelle image
                    rotation_featured_image: 0 // Réinitialiser la rotation pour la nouvelle image
                }));
            }
        } else {
            setFormData(prevData => ({
                ...prevData,
                [name]: type === 'checkbox' ? checked : value
            }));
        }
    };

    // Nouvelle fonction pour supprimer l'image
    const handleRemoveImage = () => {
        if (formData.imagePreview) {
            URL.revokeObjectURL(formData.imagePreview);
        }
        
        setFormData(prevData => ({
            ...prevData,
            image: null,
            imagePreview: '',
            currentImage: null,
            copyright: true, // Réinitialise le copyright car pas d'image
            rotation_featured_image: 0 // Réinitialiser la rotation quand on supprime l'image
        }));
        
        const fileInput = document.getElementById('image');
        if (fileInput) {
            fileInput.value = '';
        }
    };

    useEffect(() => {
        return () => {
            if (formData.imagePreview && formData.imagePreview !== formData.currentImage) {
                URL.revokeObjectURL(formData.imagePreview);
            }
        };
    }, [formData.imagePreview, formData.currentImage]);

    const handleSubimeChange = (content) => {
        setFormData(prevData => ({
            ...prevData,
            description: content
        }));
    }

    // Vérifie si le formulaire peut être soumis
    const isSubmitDisabled = (formData.image && !formData.copyright);

    const handleArticleToFavorite = async (title, link, image, country, date, description) => {
        const favorite = {
          title: title,
          link: link,
          image: image || "",
          country: country,
          publication_date: date,
          description: description
        };
    
        try {
          const res = await addFavorite(favorite);
          if (res.ok === true) {
            favorite.id = res.id;
            const updatedFavorites = [favorite, ...favorites];
            setFavorites(updatedFavorites);
            localStorage.setItem('favorites', JSON.stringify(updatedFavorites));
            alert('Article added to favorites !');
          }
        } catch (error) {
          console.error('An error has occured when adding the favorite', error);
          alert('An error has occured when adding the favorite');
        }
      };
    
      const handleRemoveFromFavorite = async (link) => {
        try {
          const res = await removeFavorite({ link });
          if (res) {
            console.log(favorites)
            const updatedFavorites = favorites.filter(fav => fav.link !== link);
            console.log(updatedFavorites)
            setFavorites(updatedFavorites);
            localStorage.setItem('favorites', JSON.stringify(updatedFavorites));
            alert('Article removed from favorites !');
          }
        } catch (error) {
          console.error('An error has occured when deleting the favorite', error);
          alert('An error has occured when deleting the favorite');
        }
      };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // Si l'image a été supprimée, on l'indique dans la mise à jour
            const visibleArticle = Number(formData.visible);
            const updateData = {
                id: formData.id,
                user_id: formData.user_id,
                title: formData.title,
                description: formData.description,
                language: formData.language,
                visible: visibleArticle,
                remove_image: !formData.currentImage && !formData.image, // Ajouter ce flag si nécessaire dans votre API
                rotation_featured_image: formData.rotation_featured_image // S'assurer que cette valeur est envoyée
            };
            console.log("Données envoyées pour mise à jour:", updateData);
            
            const res = await updateArticle(updateData);
            if (res) {
                console.log("Article mis à jour avec succès");
            }

            if (res && visibleArticle === 1 && !favorites.find(fav => fav.link === `https://static.zemus.info/article/?id=${formData.id}`)) {
                await handleArticleToFavorite(formData.title, `https://static.zemus.info/article/?id=${formData.id}`, constants.API_URL + `/article/${formData.id}/featured_image`, countries.find((country) => country.code === user.country).name, new Date().toISOString().replace("T", " ").slice(0, 19), formData.description.replace(/<[^>]+>/g, '').slice(0, 200) + '...')
            } else if (res && visibleArticle !== 1 && favorites.find(fav => fav.link === `https://static.zemus.info/article/?id=${formData.id}`)) {
                await handleRemoveFromFavorite(`https://static.zemus.info/article/?id=${formData.id}`)
            }
            
            if (formData.image) {
                await uploadFeaturedImage(formData.id, formData.image);
                alert('Article mis à jour avec succès avec la nouvelle image');
            } else {
                alert('Article mis à jour avec succès');
            }
            
            window.location.href = '/myarticles';
        } catch (err) {
            console.error("Erreur lors de la mise à jour:", err);
            alert("Une erreur est survenue lors de la mise à jour de l'article");
        }
    };

    const handleRotateImage = () => {
        if (formData.imagePreview) {
            // Mettre à jour la rotation_featured_image dans l'état
            setFormData(prevData => ({
                ...prevData,
                rotation_featured_image: (prevData.rotation_featured_image + 90) % 360
            }));
            console.log("Rotation appliquée:", (formData.rotation_featured_image + 90) % 360);
        }
    }

    return (
        <div className="mt-8 max-w-md mx-auto p-6 bg-white rounded-lg shadow-md md:overflow-y-auto" style={{ maxHeight: window.innerWidth >= 768 ? 'calc(100vh - 100px)' : undefined }}>
            <h2 className="text-2xl font-bold mb-6 text-center">Édition de l'Article</h2>
            <form onSubmit={handleSubmit}>
                <div className="mb-4">
                    <label htmlFor="title" className="block text-gray-700 text-sm font-bold mb-2">
                        Titre
                    </label>
                    <input
                        type="text"
                        id="title"
                        name="title"
                        value={formData.title}
                        onChange={handleChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="language" className="block text-gray-700 text-sm font-bold mb-2">
                        Langue de l'article
                    </label>
                    <select 
                        value={formData.language} 
                        onChange={handleChange} 
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" 
                        name="language"
                    >
                        {languages.map((l, i) => (
                            <option value={l.language_code} key={i}>{l.language_name}</option>
                        ))}
                    </select>
                </div>
                <div className="mb-4">
                    <label htmlFor="image" className="block text-gray-700 text-sm font-bold mb-2">
                        Afficher une image
                    </label>
                    <div className="flex gap-2">
                        <input
                            type="file"
                            id="image"
                            name="image"
                            accept="image/*"
                            onChange={handleChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        />
                        {(formData.image || formData.currentImage) && (
                            <>
                            <button
                                type="button"
                                onClick={handleRotateImage}
                                className="bg-blue-500 hover:bg-blue-700 text-white font-bold px-3 rounded focus:outline-none focus:shadow-outline"
                                >
                                <RotateRightIcon />
                            </button>
                            <button
                                type="button"
                                onClick={handleRemoveImage}
                                className="bg-red-500 hover:bg-red-700 text-white font-bold px-3 rounded focus:outline-none focus:shadow-outline"
                            >
                                <DeleteIcon />
                            </button>
                            </>
                        )}
                    </div>
                    {formData.imagePreview && (
                        <div className="mt-2 relative overflow-hidden w-full h-56 flex items-center justify-center">
                            {/* Conteneur avec une hauteur fixe et overflow hidden */}
                            <div className="w-4/5 h-4/5 flex items-center justify-center">
                                <img
                                    src={formData.imagePreview}
                                    alt="Preview"
                                    className="image-preview max-w-full max-h-full object-contain"
                                    style={{ 
                                        transform: `rotate(${formData.rotation_featured_image}deg)`,
                                        transformOrigin: 'center center',
                                        transition: 'transform 0.3s ease'
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </div>
                {(formData.image || formData.currentImage) && (
                    <div className="mb-6">
                        <label className="flex items-center">
                            <input
                                type="checkbox"
                                name="copyright"
                                checked={formData.copyright}
                                onChange={handleChange}
                                className="form-checkbox h-5 w-5 text-blue-600"
                            />
                            <span className="ml-2 text-gray-700">Je suis l'auteur de l'image à la une ou j'ai les droits d'utilisation</span>
                        </label>
                    </div>
                )}
                <div className="mb-4">
                    <label htmlFor="description" className="block text-gray-700 text-sm font-bold mb-2">
                        Description
                    </label>
                    <span className="text-gray-500 text-xs">Conseil : copiez et collez des images libres de droits depuis Internet.</span>
                    <ReactQuill
                        theme="snow"
                        value={formData.description}
                        onChange={handleSubimeChange}
                        className="notranslate mt-1"
                    />
                </div>
                <div className="mb-6">
                    <label htmlFor="visible" className="block text-gray-700 text-sm font-bold mb-2">
                        Visibilite
                    </label>
                    <select
                        id="visible"
                        name="visible"
                        value={formData.visible}
                        onChange={handleChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                        {VISIBILITY_OPTIONS.map((option) => (
                            <option value={option.value} key={option.value}>{option.label}</option>
                        ))}
                    </select>
                </div>
                <div className="flex items-center justify-between">
                    <button
                        type="submit"
                        disabled={isSubmitDisabled}
                        className={`${
                            isSubmitDisabled 
                            ? 'bg-gray-400 cursor-not-allowed' 
                            : 'bg-blue-500 hover:bg-blue-700'
                        } text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline`}
                    >
                        Enregistrer
                    </button>
                </div>
            </form>
        </div>
    );
}
